// modules
import React, { Component } from 'react';
import ReactGA from 'react-ga';
import axios from 'axios';

// local
import { Animate, Chart, Item, Logo, ValueProp, FeatureList, Footer } from './components';
import './App.css';


const formAPI = '/.netlify/functions/signup';


export default class App extends Component {

  constructor(props) {
    super(props);

    this.state = {
      loading: false,

      success: false,
      error: false,
      isOpen: false,
      seconds: 6
    };


    ReactGA.initialize('UA-136671855-2');
    ReactGA.pageview(window.location.pathname + window.location.search);

  }

  componentDidMount() {
    setTimeout(this.toggle, 250);
  }

  toggle = () => this.setState(prevState  => ({ isOpen: !prevState.isOpen }));

  handleSubmit = (event, data) => {
    event.preventDefault();
    const email = this.email.value;

    if (!email) {
      alert('Please email your email')
    }

    this.setState({ loading: true });

    ReactGA.event({
      category: 'User',
      action: 'Form Submission'
    });

    formHandler(email).then(() => {
      this.setState({
        success: true,
        loading: false,
      })
    }).catch((e) => {
      this.setState({
        error: true,
        loading: false,
      })
    })
  };

  renderForm() {
    const { success, loading } = this.state;
    const buttonText = (loading) ? <img className={ 'SignUpForm__loading' } src={ '/_img/button-thinking.gif' } alt={ 'loading' } /> : 'Get Notified';
    const handler = (loading) ? noOp : this.handleSubmit;

    /* if they submitted the form, show thanks */
    if (success) {
      return (
        <form className={ 'SignUpForm__form' } onSubmit={ handler }>
          <input
            type={ 'email' }
            name={ 'email' }
            className={ 'SignUpForm__input SignUpForm__input--disabled' }
            ref={input => this.email = input}
            placeholder={ 'Thank you!' }
            required
            disabled
          />
          <button className={ 'SignUpForm__button SignUpForm__button--success' } type={ 'submit' }>
            <img className={ 'SignUpForm__check' } src={ '/_img/button-check.gif' } alt={ 'check' } />
          </button>
        </form>)
    }

    return (
      <form className={ 'SignUpForm__form' } onSubmit={ handler }>
        <input
          type={ 'email' }
          name={ 'email' }
          className={ 'SignUpForm__input' }
          ref={input => this.email = input}
          placeholder={ 'Your email here' }
          required
        />
        <button className={ `SignUpForm__button ${ loading ? 'SignUpForm__button--loading' : '' }` } type={ 'submit' }>
          { buttonText }
        </button>
      </form>
    )
  }

  render() {
    const { isOpen } = this.state;
    return (
      <div>
        <div className={ 'App__background' }>{ '' }</div>
        <Animate pose={ isOpen ? 'open' : 'closed' }>
          <div className={ 'Grid' }>
            <Item>
              <Logo />
            </Item>
            <Item>
              <Chart />
            </Item>
            <Item>
              <ValueProp />
            </Item>
            <Item>
              <FeatureList />
            </Item>
          </div>
          {/* <Item>
            <div className={ 'SignUpForm__section' }>
              <div className={ 'SignUpForm__wrapper' }>
                <div className={ 'SignUpForm__container' }>
                  <h3 className={ 'SignUpForm__title' }>{ 'Interested?' }</h3>
                  <p className={ 'SignUpForm__text' }>{ 'Sign up to get updates and be notified when Momentum launches in late 2019. ' }</p>
                  { this.renderForm() }
                </div>
                <Footer />
              </div>
            </div>
          </Item> */}
        </Animate>
      </div>
    )
  }
}

function formHandler(email) {
  const data = {
    email: email
  };

  return axios({
    method: 'post',
    url: formAPI,
    data: data,
  });
}

function noOp() {
  console.log('submission in progress')
}



// WEBPACK FOOTER //
// ./src/App.js